module.exports = __webpack_public_path__ + "static/media/CV.436b2b11.png";